import { changePasswordActionCreators } from '@app/components/ChangePasswordModal/modules/changePassword'
import { preferencesEditActionCreators } from '@app/components/PreferencesModal/modules/preferencesEdit'
import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { actionCreators } from '@app/store/modules/account'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import Header from '../components/Header'

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, ICurrentUserState>({
      user: selectCurrentUser(),
    }),
    {
      ...actionCreators,
      ...changePasswordActionCreators,
      ...preferencesEditActionCreators,
    },
  )(Header),
)
